import moment from 'moment'

export const datas = (val, format = 'DD/MM/YYYY HH:mm') => {
  if (val) return moment(val).format(format)

  return '-'
}
